export default "__VITE_ASSET__CDsc1Kxz__"